import { Collection, Database, Q } from '@nozbe/watermelondb';

import { EntryProcedureDBServiceOptions } from '../../types/dbService';
import {
    EntryProcedureModel,
    PreparedDataOnEntryProcedureUpdate,
} from '../../types/EntryProcedure';
import { DatabaseValidation } from '../../types/validation';
import { addRelatedDataBatch } from './helpers/entryProcedure/common';
import {
    appendPreparedEntryProcedures,
    logBumpDBActions,
} from './helpers/entryProcedure/entryProcedureBump';
import { validateEntityRecords } from './helpers/common/validateEntityRecords';

class EntryProcedure {
    private database: Database;
    private collection: Collection<EntryProcedureModel>;
    private table = 'entry_procedures';
    private options: EntryProcedureDBServiceOptions;
    private validation: DatabaseValidation;

    constructor(options: EntryProcedureDBServiceOptions) {
        this.database = options.database;
        this.collection = options.database.collections.get(this.table);
        this.options = options;
        this.validation = options.validation;
    }

    getAll() {
        return this.collection.query().fetch();
    }

    getAllQuery() {
        return this.collection.query();
    }

    getByID(id: string) {
        return this.collection.find(id);
    }

    async getByParam(param: string, value: any) {
        return this.collection.query(Q.where(param, value)).fetch();
    }

    async prepareBumpUpdates(ids: string[]) {
        const procedureElements = await Promise.all(
            ids.map(async (id) => this.getByID(id)),
        );

        return procedureElements.map((procedureElement) =>
            procedureElement.prepareUpdate((procedure) => {
                procedure.name = procedureElement.name;
            }),
        );
    }

    async bump(ids: string[]) {
        await this.database.write(async () => {
            const proceduresToUpdate = await this.prepareBumpUpdates(ids);

            let preparedData: PreparedDataOnEntryProcedureUpdate[] = [];
            preparedData = appendPreparedEntryProcedures(preparedData, {
                proceduresToUpdate,
            });

            validateEntityRecords(
                preparedData.filter((r) => r.record != null),
                this.validation,
            );

            await addRelatedDataBatch(
                preparedData.map((item) => item.record),
                this.database,
            );

            logBumpDBActions({
                proceduresToUpdate,
                logDBAction: this.options.logDBAction,
                tableName: this.table,
            });
        });
    }
}

export default EntryProcedure;
